






























import Component from "vue-class-component";
import Vue from "vue";
import RadioButtonModel from "@/chipply/RadioButtonModel";
import { Prop } from "vue-property-decorator";

@Component({})
export default class ChipplyChip extends Vue {
    @Prop({
        type: Object,
    })
    button!: RadioButtonModel;

    @Prop({
        type: Boolean,
    })
    sizeVersion!: boolean;

    private styleObject = {
        height: "",
        width: "",
        maxWidth: "",
        minWidth: "",
    };

    public get screenSize() {
        if (this.sizeVersion) {
            // for size buttons
            this.styleObject.height = this.$vuetify.breakpoint.mdAndUp ? "32px" : "40px";
            this.styleObject.width = "";
            this.styleObject.maxWidth = "232px";
            this.styleObject.minWidth = "62px";
        } else {
            // for process buttons
            this.styleObject.height = "48px";
            this.styleObject.width = this.$vuetify.breakpoint.mdAndUp ? "49%" : "100%";
            this.styleObject.maxWidth = this.$vuetify.breakpoint.mdAndUp ? "49%" : "100%";
        }
        return this.styleObject;
    }

    private chipClicked() {
        this.$emit("chipClicked");
    }

    public get isTooltipDisabled() {
        if (
            (!this.sizeVersion && this.button.display.length < 58) ||
            (this.sizeVersion && this.button.display.length < 21)
        ) {
            return true;
        } else return false;
    }
}
